module.exports = __webpack_public_path__ + "img/powershell.b61820fd.svg";